export default function ServiceNoteField({ value, onChange, onBlur, testId = "service-note" }) {
    return (
        <div>
            <label className="label-kicker mb-1 block text-slate-500">Shënim shtesë (opsional)</label>
            <textarea
                rows="2"
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                maxLength={3000}
                placeholder="Shkruaj këtu çdo shërbim tjetër që nuk është në listë..."
                className="input-field !text-xs"
                data-testid={testId}
            />
        </div>
    );
}
